var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNoTextBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.0721 30.0103C81.953 17.2631 71.9168 7.18869 59.218 3.05383C23.8526 -8.4598 -8.32679 23.8423 3.14309 59.3427C7.26223 72.0899 17.2984 82.1644 29.9972 86.2992C65.3626 97.8128 97.5648 65.5107 86.0721 30.0103ZM70.2328 62.7008C70.2328 63.7974 69.3452 64.6883 68.2529 64.6883H47.3385H15.7053H14.2716L14.4081 63.1806C15.9102 51.3471 37.621 31.6095 43.7428 26.9035H23.3064C22.214 26.9035 21.3037 26.0126 21.3037 24.8932H47.0199H47.0427H78.3345L76.4456 26.7436C56.7375 45.7502 49.4778 59.4112 47.9075 62.7008H70.2328Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8287 26.8806C55.7135 28.0685 30.3615 54.6595 28.4043 62.7693H30.0884C30.1339 62.5637 29.9973 62.9978 30.0884 62.7693C32.3186 56.4186 46.5194 40.336 53.8929 32.2948C56.4873 29.4392 59.0589 26.9491 59.1272 26.8806H56.8287V26.8806Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoTextBlack);
export default __webpack_public_path__ + "static/media/logo-noText-black.46dcd7c7a384b2f72df1c6f17f1aac49.svg";
export { ForwardRef as ReactComponent };